import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import {
  TransportPlannerProfileItemState,
  TransportPlannerProfileItemStateModel,
} from './transport-planner-profile-item.state';
import {
  TransportPlannerProfileItemClone,
  TransportPlannerProfileItemCreate,
  TransportPlannerProfileItemDelete,
  TransportPlannerProfileItemInitialState,
  TransportPlannerProfileItemLoad,
  TransportPlannerProfileItemSave,
  TransportPlannerProfileItemUpdate,
} from './transport-planner-profile-item.actions';
import { TransportPlannerProfileDetails, TransportPlannerProfileModel } from '../models';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogAfterClosedModel } from '../../../../../ui-kit';

@Injectable({ providedIn: 'root' })
export class TransportPlannerProfileItemFacade implements LoadDataFacade, SetInitialStateFacade {
  profileId$: Observable<number> = this.store.select(TransportPlannerProfileItemState.getProfileId);
  profile$: Observable<TransportPlannerProfileItemStateModel> = this.store.select(
    TransportPlannerProfileItemState.getState,
  );
  loaded$: Observable<boolean> = this.store.select(TransportPlannerProfileItemState.getLoaded);

  constructor(private store: Store) {}

  loadAll(transportPlannerProfileId: number): void {
    this.store.dispatch(new TransportPlannerProfileItemLoad(transportPlannerProfileId));
  }

  createProfile(profile: TransportPlannerProfileModel, dialog: MatDialogRef<unknown>): void {
    this.store.dispatch(new TransportPlannerProfileItemCreate({ dialog, profile }));
  }

  saveProfile(profile: TransportPlannerProfileDetails): void {
    this.store.dispatch(new TransportPlannerProfileItemSave(profile));
  }

  updateProfile(data: TransportPlannerProfileModel): void {
    this.store.dispatch(new TransportPlannerProfileItemUpdate(data));
  }

  cloneProfile(data: TransportPlannerProfileModel): void {
    this.store.dispatch(new TransportPlannerProfileItemClone(data));
  }

  deleteProfile(profileId: number, dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>): void {
    this.store.dispatch(new TransportPlannerProfileItemDelete({ dialog, profileId }));
  }

  setInitialState(): void {
    this.store.dispatch(new TransportPlannerProfileItemInitialState());
  }
}
